import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import LogoImage from '../../Abstracts/LogoImage/LogoImage';
import Hamburger from 'hamburger-react';
import Basket from './Icons/Basket/Basket';
import IconLink from './Icons/IconLink/IconLink';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import Search from './Search/Search';
import MenuDesktop from './MenuDesktop/MenuDesktop';
import UserMenu from './UserMenu/UserMenu';
import { useUser } from '../../Context/UserContext';
import Link from '../../Abstracts/Link/Link';
import NcwMarquee from '../NewcomerWeek/Abstracts/NcwMarquee/NcwMarquee';
import UserLoginPopUp from '../../Abstracts/Modals/UserLoginPopUp/UserLoginPopUp';
import useHeaderVisibility from '../../Hooks/useHeaderVisibility';
import style from './Header.module.scss?module';

export default function Header({
  setSidebarOpen,
  sidebarOpen,
}: {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarOpen: boolean;
}) {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const isVisible = useHeaderVisibility();

  const { user, basketInfo } = useUser();
  return (
    <>
      <UserLoginPopUp
        showLoginPopup={showLoginPopup}
        setShowLoginPopup={setShowLoginPopup}
        onLoginSuccess={() => {
          setShowLoginPopup(false);
        }}
      />
      <div
        className={[
          style.header,
          !isVisible ? style.headerHidden : '',
        ].join(' ')}
      >
        {Date.now() > Date.UTC(2025, 2, 9, 22, 0, 0) &&
          Date.now() < Date.UTC(2025, 2, 16, 21, 59, 59) && (
            <Link href={'/newcomer-week/home'} opacityOnHover={false}>
              <NcwMarquee fluid />
            </Link>
          )}

        <Container>
          <Row className={'pt-4 d-none d-lg-block'}>
            <Col className={'d-flex justify-content-between'}>
              <div className={style.logo}>
                <LogoImage className={'w-100'} />
              </div>
              <div style={{ paddingTop: '3px' }}>
                <MenuDesktop />
              </div>
              <div>
                <Search />
              </div>
              <div style={{ paddingTop: '6px' }}>
                <UserMenu user={user} />
              </div>
              {basketInfo && (
                <div style={{ paddingTop: '6px' }}>
                  <Basket basketInfo={basketInfo} />
                </div>
              )}
            </Col>
          </Row>

          <Row className="d-lg-none align-items-center justify-content-between px-3">
            <Col xs={3} md={4} className="p-0">
              <div className={style.hamburgerContainer}>
                <Hamburger
                  size={25}
                  toggle={setSidebarOpen}
                  toggled={sidebarOpen}
                />
              </div>
            </Col>
            <Col xs={5} md={4} className="p-0">
              <LogoImage />
            </Col>
            <Col xs={3} md={4} className="p-0 d-flex justify-content-end">
              {user && user.id ? (
                <Basket basketInfo={basketInfo} />
              ) : (
                <IconLink
                  icon={faUser}
                  onClick={() => setShowLoginPopup(true)}
                />
              )}
            </Col>
          </Row>

          <Row className={'d-lg-none pb-4'}>
            <Col xs={12}>
              <Search />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
